function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.3726 84H15C6.71573 84 0 77.2843 0 69V51C0 42.7157 6.71573 36 15 36H38.3726L74.5 5.4404L74.5 114.56L38.3726 84Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M137.615 26.8086C144.11 37.487 147.703 49.6753 148.015 62.1167C148.328 74.5587 145.349 86.8077 139.373 97.5933C133.398 108.38 124.644 117.306 114.016 123.442C112.103 124.547 109.657 123.891 108.552 121.978C107.448 120.065 108.103 117.619 110.016 116.514C119.379 111.109 127.099 103.24 132.375 93.7164C137.652 84.1918 140.295 73.3527 140.018 62.3176C139.741 51.2818 136.553 40.4566 130.78 30.9662C125.007 21.4759 116.863 13.6739 107.199 8.36419C105.262 7.30048 104.555 4.86858 105.619 2.93239C106.683 0.996208 109.114 0.288927 111.051 1.35264C121.95 7.34062 131.119 16.1301 137.615 26.8086Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M122.606 35.4407C127.584 43.6283 130.359 52.9637 130.638 62.4868C130.916 72.0108 128.687 81.3852 124.162 89.6358C119.637 97.8875 112.984 104.709 104.886 109.384C102.973 110.489 100.527 109.833 99.422 107.92C98.3175 106.007 98.973 103.561 100.886 102.456C107.705 98.5194 113.321 92.7688 117.148 85.7893C120.976 78.8086 122.879 70.8459 122.641 62.7205C122.404 54.5942 120.034 46.609 115.771 39.5969C111.507 32.5848 105.513 26.813 98.416 22.8742C96.4845 21.8021 95.7877 19.3672 96.8598 17.4356C97.9319 15.5041 100.367 14.8073 102.298 15.8794C110.62 20.4983 117.628 27.2531 122.606 35.4407Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M109.886 43.8926C113.322 49.5429 115.238 55.9869 115.43 62.5638C115.623 69.1416 114.083 75.6219 110.953 81.3299C107.822 87.0391 103.217 91.7619 97.6091 94.9996C95.6959 96.1042 93.2496 95.4487 92.145 93.5355C91.0404 91.6224 91.6959 89.176 93.6091 88.0714C97.9377 85.5723 101.505 81.9204 103.938 77.4834C106.372 73.0453 107.585 67.9767 107.434 62.7975C107.282 57.6174 105.772 52.5235 103.051 48.0487C100.33 43.574 96.5061 39.8932 91.9833 37.3829C90.0517 36.3109 89.355 33.8759 90.4271 31.9444C91.4991 30.0128 93.9341 29.3161 95.8656 30.3881C101.614 33.5785 106.451 38.2422 109.886 43.8926Z"
});

function SvgAudioOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 124,
    viewBox: "0 0 149 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOn);
export default __webpack_public_path__ + "static/media/audio_on.45bb107a.svg";
export { ForwardRef as ReactComponent };